import _ from 'underscore';

/**
 * 피망 도메인의 베이스 도메인을 치환
 * @param {*} baseDomain 예) 베이스 도메인 game.daum.net
 */
function getDomainMappings(baseDomain) {
  return {
    // CDN
    '//file.pmang.com': `//pmfile.${baseDomain}`,
    '//file.pmang.kr': `//pmfile.${baseDomain}`,
    '//mm.file.com': `//mm.pmang.${baseDomain}`,
    '//mm.file.kr': `//mm.pmang.${baseDomain}`,
    '//webboard-static.pmang.com': `//webboard-static.pmang.${baseDomain}`,
    '//webboard-static-dq.pmang.com': `//webboard-static-dq.pmang.${baseDomain}`,
    '//webboard-static-tq.pmang.com': `//webboard-static-tq.pmang.${baseDomain}`,
    // 피망
    '//www.pmang.com': `//pmang.${baseDomain}`,
    '//memo.pmang.com': `//memo.pmang.${baseDomain}`,
    '//chat.pmang.com': `//chat.pmang.${baseDomain}`,
    '//member.pmang.com': `//pmangmember.${baseDomain}`,
    '//pmangmall.pmang.com': `//mall.pmang.${baseDomain}`,
    '//help.pmang.com': `//help.pmang.${baseDomain}`,
    '//helpdesk.pmang.com': `//help.pmang.${baseDomain}`, // 2022년 11월 고객센터 도메인 변경
    '//my.pmang.com': `//pmangmember.${baseDomain}`,
    '//account.pmang.com': `//account.pmang.${baseDomain}`,
    '//accounts.pmang.com': `//accounts.pmang.${baseDomain}`,
    '//channels.pmang.com': `//channels.pmang.${baseDomain}`,
    '//certifications.pmang.com': `//certifications.pmang.${baseDomain}`,
    '//cs.pmang.com': `//cs.pmang.${baseDomain}`,
    // 웹보드 게임
    '//boardgame.pmang.com': `//boardgame.pmang.${baseDomain}`,
    '//board.pmang.com': `//board.pmang.${baseDomain}`,
    '//gostop.pmang.com': `//gostop.pmang.${baseDomain}`,
    '//poker.pmang.com': `//poker.pmang.${baseDomain}`,
    '//vegas.pmang.com': `//vegas.pmang.${baseDomain}`,
    '//sudda.pmang.com': `//sudda.pmang.${baseDomain}`
  };
}

/**
 * 치환할 도메인의 배열을 만든다
 * [{ asis: '//www.pmang.com', tobe: '//pmang.game.daum.net'} ... ]
 * @param {*} maps
 */
function prepareList(mapping) {
  var keys = _.keys(mapping);
  var newMappings = [];

  _.each(keys, function (key) {
    newMappings.push({
      asis: key,
      tobe: mapping[key]
    });
  });

  return newMappings;
}

/**
 * 배열을 돌며 asis 의 값으로 정규표현식을 만든 후, tobe의 값으로 전부 치환한다.
 * @param {*} text 바꿀 텍스트
 * @param {*} list prepareList 로 만든 치환 목록
 */
function replaceAll(text, list) {
  var result = text;
  _.each(list, function (el) {
    result = result.replace(new RegExp(el.asis, 'g'), el.tobe);
  });
  return result;
}

var replaceFn = {
  'boardgame.pmang.game.daum.net': function (text) {
    return replaceAll(text, prepareList(getDomainMappings('game.daum.net')));
  },
  'poker.pmang.game.daum.net': function (text) {
    return replaceAll(text, prepareList(getDomainMappings('game.daum.net')));
  },
  'gostop.pmang.game.daum.net': function (text) {
    return replaceAll(text, prepareList(getDomainMappings('game.daum.net')));
  },
  'sudda.pmang.game.daum.net': function (text) {
    return replaceAll(text, prepareList(getDomainMappings('game.daum.net')));
  },
  'vegas.pmang.game.daum.net': function (text) {
    return replaceAll(text, prepareList(getDomainMappings('game.daum.net')));
  }
};

export var domainReplacer = {
  create: function create() {
    var key = window.location.host; // 현재 도메인 주소에 따라 작동
    var fn = replaceFn[key];

    if (_.isFunction(fn)) {
      return fn;
    }
    return function (text) {
      return text; // noop
    };
  }
};
